import axios from '@/service/request';
import type { R } from './types';

/**
 * 用户信息修改请求参数
 */
export interface BuyerModifyRequest {
  /** 用户id */
  buyerId?: string;
  /** 手机 */
  mobile?: string;
  /** 邮箱 */
  email?: string;
  /** 用户头像 */
  headimgurl?: string;
  /** 昵称 */
  nickname?: string;
  /** 真实姓名 */
  realName?: string;
  /** 原始密码 */ 
  password?: string;
  /** 新密码 */
  newPassword?: string;
  /** 新密码确认 */
  newConfirmPassword?: string;
}

/**
 * 用户信息修改
 */
export const apiBuyerModify = (data: BuyerModifyRequest): Promise<R<boolean>> => {
  return axios.post('/buyer/modify', data);
};

